import config from '../config';
import fb from './fb';
import twitter from './twitter';
import google from './google';

const cache = UpSDK.cache;

const sns = {
    /**
     * 前往sns平台进行授权获取code(统一接口提供给外部调用)
     */
    jumpToSNS: function(platfrom, scope) {
        this[platfrom + 'JumpForCode'](scope);
    },
    /**
     * 前往微信授权中心
     */
    wechatJumpForCode: function(scope) {
        let self = this;
        let urlForCode = 'https://open.weixin.qq.com/connect/oauth2/authorize?';
        let wechat = config.upInfoInPlatform.wechat;
        let appid;

        if (Uplib.url.query('env') == 'stage') {
            appid = wechat['appid_stage'];
        } else {
            appid = wechat.appid;
        }

        var result = {
            appid: appid,
            redirect_uri: self.getRedirectUri(),
            response_type: 'code',
            scope: 'snsapi_base',
            state: '1'
        };

        if (scope == 'snsapi_userinfo') {
            Object.assign(result, {
                scope: scope,
                state: '2'
            });
        }

        self.jump(urlForCode + $.param(result) + '#wechat_redirect');
    },


    qqJumpForCode: function() {

        var urlForCode = 'https://graph.qq.com/oauth2.0/authorize?display=mobile&response_type=code&scope=get_user_info';
        var result = {
            client_id : '101402313',
            state : Uplib.url.query('stage'),
            redirect_uri : this.getRedirectUri()
        };

        this.jump(urlForCode + '&' + $.param(result));
    },

    twitterJumpForCode: function(requestToken) {
        let urlForCode = 'https://api.twitter.com/oauth/authenticate?oauth_token=' + requestToken;
        this.jump(urlForCode);
    },


    weiboJumpForCode: function() {
        var urlForCode = 'https://api.weibo.com/oauth2/authorize';

        var result = {
            client_id: config.upInfoInPlatform.weibo.appid,
            response_type: 'code',
            redirect_uri: this.getRedirectUri()
        };

        this.jump(urlForCode + '?' + $.param(result));
    },

    lineJumpForCode: function() {
        var urlForCode = 'https://access.line.me/oauth2/v2.1/authorize?';
        var href = location.href;
        href = Uplib.url.delQuery(href, 'code');
        href = Uplib.url.delQuery(href, 'state');
        href = href.replace(/#.*/, '');

        var result = {
            response_type: 'code',
            // client_id: '1575942563',
            client_id: '1542604681',
            state: (+new Date()),
            scope: 'profile openid',
            redirect_uri: href
        };

        this.jump(urlForCode+$.param(result));
    },

    /**
     * 获得重定向URL
     */
    getRedirectUri: function() {
        let [baseUrl, hash] = location.href.split('#');
        // 微信、微博。授权参数code
        // facebook 没有额外授权参数
        baseUrl = Uplib.url.delQuery(baseUrl, 'code');
        baseUrl = Uplib.url.delQuery(baseUrl, 'state');
        // twitter。。授权参数oauth_token，oauth_verifier
        baseUrl = Uplib.url.delQuery(baseUrl, 'oauth_token');
        baseUrl = Uplib.url.delQuery(baseUrl, 'oauth_verifier');

        cache.setCache('redirectHash', hash);

        return baseUrl;
    },

    /**
     * 链接跳转
     */
    jump: function(url) {
        cache.setCache('isBackFromSNS', true);
        cache.setCache('bizoauthtype', UpSDK.config.oauthtype);
        location.replace(url);
    }
};

export default sns;
export {
    fb,
    twitter,
    google
};



// WEBPACK FOOTER //
// ./js/component/openjs/deps/login/sns/index.js